// src/pages/MagicLogin.js
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MagicLogin = () => {
  const { token } = useParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const hasValidated = useRef(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hasValidated.current) return;
    hasValidated.current = true;

    const validateToken = async () => {
      console.log('[MagicLogin] Validating token:', token);
      try {
        const res = await fetch(`http://localhost:8000/api/magic-login/${token}/`);
        if (!res.ok) {
          console.warn('❌ Magic token is invalid or expired.');
          navigate('/expired');
          return;
        }

        const data = await res.json();
        console.log('[MagicLogin] Token response:', data);

        if (data.client_id && data.project_id) {
          console.log('[MagicLogin] Logging in user...');
          login(token, { id: data.client_id }, { id: data.project_id });

          console.log('[MagicLogin] Marking token as used...');
          await fetch(`http://localhost:8000/api/magic-link-used/${token}/`, {
            method: 'POST'
          });

          console.log('[MagicLogin] Redirecting to dashboard...');
          setTimeout(() => {
            navigate(`/client-dashboard/${data.project_id}`);
          }, 100);
        } else {
          console.warn('❌ Missing client/project info');
          navigate('/expired');
        }
      } catch (err) {
        console.error('❌ Magic login failed:', err);
        navigate('/expired');
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, [token, login, navigate]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px', fontSize: '1.2rem' }}>
        Logging you in...
      </div>
    );
  }

  return null;
};

export default MagicLogin;